import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      position: relative;\n      line-height: normal;\n    "])));
  },
  rootMobile: function rootMobile(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      width: ", ";\n      max-width: ", ";\n    "])), t.selectRootWidthMobile, t.mobileSelectMaxWidth);
  },
  placeholder: function placeholder(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n      text-overflow: ellipsis;\n    "])), t.selectPlaceholderColor);
  },
  placeholderDisabled: function placeholderDisabled(t) {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n    "])), t.selectPlaceholderColorDisabled);
  },
  customUsePlaceholder: function customUsePlaceholder() {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      color: inherit;\n      opacity: 0.7;\n    "])));
  },
  arrowWrap: function arrowWrap(t) {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n      flex-shrink: 0;\n    "])), t.selectMenuArrowColor);
  },
  arrowDisabled: function arrowDisabled(t) {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n    "])), t.selectMenuArrowColorDisabled);
  },
  customUseArrow: function customUseArrow() {
    return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n      color: inherit;\n      opacity: 0.7;\n    "])));
  },
  label: function label() {
    return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n      flex: 1 1 auto;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n    "])));
  },
  search: function search() {
    return css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n      margin: 1px 4px 4px;\n    "])));
  },
  leftIconSmall: function leftIconSmall(t) {
    return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n      margin-right: ", ";\n      width: ", ";\n    "])), t.selectIconGapSmall, t.btnIconSizeSmall);
  },
  leftIconMedium: function leftIconMedium(t) {
    return css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n      margin-right: ", ";\n      width: ", ";\n    "])), t.selectIconGapMedium, t.btnIconSizeMedium);
  },
  leftIconLarge: function leftIconLarge(t) {
    return css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n      margin-right: ", ";\n      width: ", ";\n    "])), t.selectIconGapLarge, t.btnIconSizeLarge);
  },
  leftIconLink: function leftIconLink(t) {
    return css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteralLoose(["\n      margin-right: ", ";\n    "])), t.btnLinkIconMarginRight);
  },
  selectButtonContainer: function selectButtonContainer() {
    return css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteralLoose(["\n      width: 100%;\n      display: inline-flex;\n      justify-content: space-between;\n    "])));
  }
});